export default "__VITE_ASSET__A8_yolkX__"